import { registerFragment } from "@cedarjs/web/apollo"

registerFragment(gql`
  fragment ReviewFragment on Review {
    id
    description
    state
    date
    profile {
      fullName
    }
    batch {
      id
      name
    } 
    comments(level:0) {
      id
      idReview
      idReviewComment
      content
      models
      type
      createdAt
      review {
        state
      }
      profile {
        fullName
      }
      checks {
        id
        checked
        createdAt
        createdBy
        profile {
          id
          fullName
        }
      }
      replies {
        id
        idReview
        idReviewComment
        content
        models
        type
        createdAt
        profile {
          fullName
        }
      }
    }
  }
`)